import * as React from 'react'
import cx from 'classnames'
import styles from './Sandwich.sass'

/**
 * Props for Sandwich.
 */
interface SandwichProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Stretches the sandwich to fill the parent container.
   */
  stretch?: boolean
  /**
   * Sandwich to full width
   */
  full?: boolean
}

/**
 * A Sandwich has buns and content. The buns are fixed in size,
 * and the content is flexible.
 *
 * I love everything about this component.
 * This is probably Steve's favorite piece of code, too.
 */
export function Sandwich({
  children,
  stretch,
  full,
  className,
}: SandwichProps) {
  return (
    <div
      className={cx(
        styles.sandwich,
        stretch && styles.stretch,
        full && styles.full,
        className
      )}
    >
      {children}
    </div>
  )
}

/**
 * Props for SandwichBun
 */
export interface SandwichBunProps
  extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * Goes on top and/or the bottom of a SandwichContent, but inside Sandwich.
 *
 * If you only use one bun, is it technically a sandwich though? 🤔
 */
export function SandwichBun({ children }: SandwichBunProps) {
  return <div className={cx(styles.bun)}>{children}</div>
}

/**
 * Props for SandwichContent.
 */
export interface SandwichContentProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Stretch the inner elements of the content by making the
   * <SandwichContent> a flex container similar to the <Sandwich> itself.
   * This is useful when you want a single child element of the content to
   * occupy the remaining space.
   */
  stretch?: boolean
}

/**
 * The content of the Sandwich. Fills the available space.
 */
export const SandwichContent = React.forwardRef(function SandwichContent(
  { children, stretch }: SandwichContentProps,
  ref: React.Ref<any>
) {
  return (
    <div ref={ref} className={cx(styles.content, stretch && styles.stretch)}>
      {children}
    </div>
  )
})
